<app-header></app-header>
<app-friend-profile-header></app-friend-profile-header>
<app-right-side></app-right-side>
<div class="container">
    <div class="row">
        <div class="col col-xl-6 order-xl-2 col-lg-8 order-lg-2 col-md-12 order-md-1 col-sm-12 col-12">
            <div class="ui-block">
                <div class="ui-block-title">
                    <h6 class="title" style="color: #093952;"><i class="fad fa-swatchbook"></i>&nbsp;Hobbies and Interests</h6>
                </div>
                <div class="ui-block-content" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                    <div class="row">
                        <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                            <!-- W-Personal-Info -->
                            <ul class="widget w-personal-info item-block">
                                <li>
                                    <span class="title" style="color: #e49a12;">Hobbies:</span>
                                    <span *ngIf="friendData.hobby1"
                                        class="text" style="color: var(--text-color);">{{ friendData.hobby1 | titlecase }}.</span>
                                    <span *ngIf="!friendData.hobby1" class="text">No information available !</span>
                                </li>
                                <li>
                                    <span class="title"style="color: #e49a12;">Favourite TV Shows:</span>
                                    <span *ngIf="friendData.hobby2"
                                        class="text" style="color: var(--text-color);">{{ friendData.hobby2 | titlecase }}.</span>
                                    <span *ngIf="!friendData.hobby2" class="text">No information available !</span>
                                </li>
                            </ul>

                            <!-- ... end W-Personal-Info -->
                        </div>
                        <div class="col col-lg-6 col-md-6 col-sm-12 col-12">


                            <!-- W-Personal-Info -->

                            <ul class="widget w-personal-info item-block">
                                <li>
                                    <span class="title" style="color: #e49a12;">Hobbies:</span>
                                    <span *ngIf="friendData.hobby3"
                                        class="text" style="color: var(--text-color);">{{ friendData.hobby3 | titlecase }}.</span>
                                    <span *ngIf="!friendData.hobby3" class="text">No information available !</span>
                                </li>
                                <li>
                                    <span class="title" style="color: #e49a12;">Favourite TV Shows:</span>
                                    <span *ngIf="friendData.hobby4"
                                        class="text" style="color: var(--text-color);">{{ friendData.hobby4 | titlecase }}.</span>
                                    <span *ngIf="!friendData.hobby4" class="text">No information available !</span>
                                </li>
                            </ul>

                            <!-- ... end W-Personal-Info -->
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="col col-xl-6 order-xl-1 col-lg-4 order-lg-1 col-md-12 order-md-2 col-sm-12 col-12">
            <div class="ui-block">
                <div class="ui-block-title">
                    <h6 class="title" style="color: #093952;"><i class="fad fa-user-circle"></i>&nbsp;Personal Info</h6>
                </div>
                <div class="ui-block-content" style="background-color: var(--backgroundpost-color); color: var(--text-color);">


                    <!-- W-Personal-Info -->

                    <ul class="widget w-personal-info">
                        <li>
                            <span class="title" style="color: #e49a12;">About Me:</span>
                            <span class="text" style="color: var(--text-color);">Hi, I’m {{friendData.fullName  | titlecase}}<br>
                                {{friendData.about}}</span>
                        </li>
                        <li>
                            <span class="title" style="color: #e49a12;">Birthday:</span>                           
                            <span *ngIf="friendData.dob" class="text" style="color: var(--text-color);">{{ friendData.dob | date  }}</span>
                            <span *ngIf="!friendData.dob" class="text" style="color: var(--text-color);">No info available !</span>
                        </li>
                        <li>
                            <span class="title" style="color: #e49a12;">Country:</span>                           
                            <span *ngIf="friendData.countryName" class="text" style="color: var(--text-color);">{{ friendData.countryName | titlecase}}</span>
                            <span *ngIf="!friendData.countryName" class="text" style="color: var(--text-color);">No info available !</span>
                        </li>
                        <li>
                            <span class="title" style="color: #e49a12;">Lives in:</span>
                            <span *ngIf="friendData.residentCountry" class="text" style="color: var(--text-color);">{{friendData.residentCountry}}</span>
                            <span *ngIf="!friendData.residentCountry" class="text" style="color: var(--text-color);">No info available !</span>
                        </li>
                        <!-- <li>
                            <span class="title">Occupation:</span>
                            <span class="text">UI/UX Designer</span>
                        </li> -->
                        <li>
                            <span class="title" style="color: #e49a12;">Joined:</span>
                           
                            <span *ngIf="friendData.created_at" class="text" style="color: var(--text-color);">{{ friendData.created_at | date }}</span>
                            <span *ngIf="!friendData.created_at" class="text" style="color: var(--text-color);">No info available !</span>
                        </li>
                        <li *ngIf="currentUser.success.user.id == 1 || currentUser.success.user.user_type_id == '1' || currentUser.success.user.user_type_id == '5'">
                            <span class="title" style="color: #e49a12;">Gender:</span>
                          
                            <span *ngIf="friendData.gender" class="text" style="color: var(--text-color);">{{ friendData.gender  | titlecase}}</span>
                            <span *ngIf="!friendData.gender" class="text" style="color: var(--text-color);">No info available !</span>
                        </li>
                        <li *ngIf="currentUser.success.user.id == 1 || currentUser.success.user.user_type_id == '1' || currentUser.success.user.user_type_id == '5'">
                            <span class="title" style="color: #e49a12;">Marital status:</span>
                            <span *ngIf="friendData.martialStatus" class="text" style="color: var(--text-color);">{{friendData.martialStatus}}</span>
                            <span *ngIf="!friendData.martialStatus" class="text" style="color: var(--text-color);">No info available !</span>
                        </li>
                        <li *ngIf="currentUser.success.user.id == 1 || currentUser.success.user.user_type_id == '1' || currentUser.success.user.user_type_id == '5'">
                            <span class="title" style="color: #e49a12;">Email:</span>
                            <a href="javascript:void(0);" class="text" style="color: var(--text-color);">{{ friendData.email | titlecase }}</a>
                        </li>
                        <!-- <li>
                            <span class="title">Website:</span>
                            <a  href="javascript:void(0);" class="text">daydreamsagency.com</a>
                        </li> -->
                        <li *ngIf="currentUser.success.user.id == 1 || currentUser.success.user.user_type_id == '1' || currentUser.success.user.user_type_id == '5'">
                            <span class="title" style="color: #e49a12;">Mobile:</span>
                           
                            <span *ngIf="friendData.mobileNumber" class="text"  style="color: var(--text-color);">{{ friendData.mobileNumber }}</span>
                            <span *ngIf="!friendData.mobileNumber" class="text" style="color: var(--text-color);">No info available !</span>
                        </li>
                        <!-- <li>
                            <span class="title">Religious :</span>
                            <span class="text">Islam</span>
                        </li> -->
                        <!-- <li>
                            <span class="title">Political :</span>
                            <span class="text">Democrat</span>
                        </li> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>